/* eslint-disable react/no-unknown-property */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React, { useState, forwardRef, useImperativeHandle } from "react";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import Select from "react-select";
import format from "date-fns/format";
import { FaCalendarAlt, FaCaretDown } from "react-icons/fa";
import moment from "moment";
import {useSelector} from "react-redux";
const CustomDateRangePicker = forwardRef(
  (
    {
      calenderFor,
      predefinedRanges,
      predefinedRangesC,
      selectedDates,
      callCompare,
      apply,
      cancel,
      openDropDown,
    },
    ref
  ) => {
    const [isFocused, setIsFocused] = useState(false);
    const [state, setState] = useState([
      {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
    ]);
    const [cState, setCState] = useState([
      {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
    ]);
    const translation = useSelector((state) => state.root.translation);
    const [open, setOpen] = useState(false);
    const [selectedRange, setSelectedRange] = useState(null);
    const [selectedRangeC, setSelectedRangeC] = useState(null);
    ////
    const [compareCalender, setCompareCalender] = useState(false);
    const urlExport = window.location.href.includes("export-data");
    const handleSelect = (ranges) => {
      setSelectedRange(""); // for only rest placholder
      setSelectedRangeC(""); // for only rest placholder
      if (!compareCalender) {
        setState([ranges.selection]);
      } else {
        setCState([ranges.selection]);
      }
      selectedDates(
        [ranges.selection],
        !compareCalender ? "selected" : "compare"
      );
    };

    const handleRangeChange = (selectedOption, type) => {
      if (type === "selected") {
        setSelectedRange(selectedOption);
      }
      if (type == "compare") {
        setSelectedRangeC(selectedOption);
        callCompare(selectedOption.value);
        return;
      }
      if (selectedOption) {
        setState([{ ...selectedOption.range, key: "selection" }]);
        selectedDates([{ ...selectedOption.range, key: "selection" }], type);
      }
    };

    // assing for compare
    const handleCompairAssign = (selectedOption) => {
      if (selectedOption) {
        // if(option){
        setCState([{ ...selectedOption.range, key: "selection" }]);
        // }else{
        //   setCState([{ ...selectedOption.range, key: "selection" }]);
        // }
        selectedDates(
          [{ ...selectedOption.range, key: "selection" }],
          "compare"
        );
      }
    };

    // Expose function to parent component using ref
    useImperativeHandle(ref, () => ({
      selectedRange,
      selectedRangeC,
      //methods
      state,
      cState,
      open,
      setOpen,
      handleRangeChange,
      handleCompairAssign,
    }));

    const openDrop = () => {
      openDropDown(calenderFor);
    };
    //

    const cancelbtn = () => {
      cancel();
      setOpen(false);
    };
    const submit = () => {
      apply();
      setOpen(false);
    };
    const today = new Date();
    const maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 1);
    maxDate.setDate(0);
    const changeMethod = (e) => {
      const { checked } = e.target;
      setCompareCalender(checked);
    };
    const handlerDateSelect = (e, op) => {
      function isValidDateFormat(dateString) {
        const regex = /^[A-Za-z]{3} \d{1,2}, \d{4}$/;
        return regex.test(dateString);
      }
      function getLocalDateString(dateInput) {
        const localDate = moment(dateInput).toDate();
        return localDate.toString();
      }
      const state1 = [...(op ? cState : state)];
      const formattedDate = getLocalDateString(e.target.value);
      if (!isValidDateFormat(e.target.value)) return;
      //
      if (formattedDate === "Invalid Date") return;
      state1[0][e.target.name] = formattedDate;
      if (!op) {
        setState(state1);
      } else {
        setCState(state1);
      }
    };
    return (
      <div className="date-range-picker">
        <div className="input-wrapper" onClick={openDrop}>
          <FaCalendarAlt className="calendar-icon" />
          <div className="calender-filter-wrap">
            {
              <div className="date-input">
                {`${format(state[0].startDate, "yyyy/MM/dd")} - ${format(
                  state[0].endDate,
                  "yyyy/MM/dd"
                )}`}
              </div>
            }

            {selectedRangeC && (
              <div className="date-input" style={{ display: urlExport ? 'none' : 'inline' }}>
                {translation?.compare_with || "Compare with"} {selectedRangeC.label}
              </div>
            )}
            {!selectedRangeC && (
              <div className="date-input" style={{ display: urlExport ? 'none' : 'inline' }}>
                {`Compare ${format(
                  cState[0].startDate,
                  "yyyy/MM/dd"
                )} - ${format(cState[0].endDate, "yyyy/MM/dd")}`}
              </div>
            )}
          </div>
          <FaCaretDown className="dropdown-icon" />
        </div>
        {open && (
          <div className="date-range-container">
            <div className="ranges-contain">
              <div className="mobile-area">
                <Select
                  value={selectedRange}
                  onChange={handleRangeChange}
                  options={predefinedRanges}
                  className="range-dropdown"
                  placeholder="Custom Range"
                />
              </div>
              <div className="predefine-content desktop-area">
                <ul>
                  {predefinedRanges?.map((item, key) => {
                    return (
                      <li
                        onClick={() => handleRangeChange(item, "selected")}
                        className={`${
                          item.value === selectedRange.value
                            ? "list-active"
                            : ""
                        }`}
                        key={key}
                      >
                        {item.label}
                      </li>
                    );
                  })}
                </ul>

                <div className="switch_box box_4" style={{ display: urlExport ? 'none' : 'flex' }}>
                  <label>{translation?.compare || "Compare"}</label>
                  <div className="input_wrapper">
                    <input
                      type="checkbox"
                      className="switch_4"
                      onChange={changeMethod}
                      checked={compareCalender}
                    />
                    <svg
                      className="is_checked"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 426.67 426.67"
                    >
                      <path d="M153.504 366.84c-8.657 0-17.323-3.303-23.927-9.912L9.914 237.265c-13.218-13.218-13.218-34.645 0-47.863 13.218-13.218 34.645-13.218 47.863 0l95.727 95.727 215.39-215.387c13.218-13.214 34.65-13.218 47.86 0 13.22 13.218 13.22 34.65 0 47.863L177.435 356.928c-6.61 6.605-15.27 9.91-23.932 9.91z" />
                    </svg>
                    <svg
                      className="is_unchecked"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 212.982 212.982"
                    >
                      <path
                        d="M131.804 106.49l75.936-75.935c6.99-6.99 6.99-18.323 0-25.312-6.99-6.99-18.322-6.99-25.312 0L106.49 81.18 30.555 5.242c-6.99-6.99-18.322-6.99-25.312 0-6.99 6.99-6.99 18.323 0 25.312L81.18 106.49 5.24 182.427c-6.99 6.99-6.99 18.323 0 25.312 6.99 6.99 18.322 6.99 25.312 0L106.49 131.8l75.938 75.937c6.99 6.99 18.322 6.99 25.312 0 6.99-6.99 6.99-18.323 0-25.313l-75.936-75.936z"
                        fillRule="evenodd"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
                {compareCalender && (
                  <ul style={{ display: urlExport ? 'none' : 'inline' }}>
                    {predefinedRangesC?.map((item, key) => {
                      return (
                        <li
                          onClick={() => handleRangeChange(item, "compare")}
                          className={`${
                            item.value === selectedRangeC.value
                              ? "list-active"
                              : ""
                          }`}
                          key={key}
                        >
                          {item.label}
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
              <div className="scrollable-calendar">
                <div className="form">
                  <div className="form-item">
                    <input
                      type="text"
                      id="startDate"
                      autoComplete="off"
                      name="startDate"
                      required
                      onChange={handlerDateSelect}
                      onFocus={() => setIsFocused(true)}
                      onBlur={() => setIsFocused(false)}
                      {...(!isFocused
                        ? {
                            value: moment(state[0]?.startDate).format(
                              "MMM DD, YYYY"
                            ),
                          }
                        : {
                            defaultValue: moment(state[0]?.startDate).format(
                              "MMM DD, YYYY"
                            ),
                          })}
                    />
                    <label htmlFor="startDate">{translation?.start_date || "Start Date"}</label>
                  </div>
                  <div className="form-item">
                    <input
                      type="text"
                      id="endDate"
                      name="endDate"
                      autoComplete="off"
                      required
                      onFocus={() => setIsFocused(true)}
                      onBlur={() => setIsFocused(false)}
                      onChange={handlerDateSelect}
                      {...(!isFocused
                        ? {
                            value: moment(state[0]?.endDate).format(
                              "MMM DD, YYYY"
                            ),
                          }
                        : {
                            defaultValue: moment(state[0]?.endDate).format(
                              "MMM DD, YYYY"
                            ),
                          })}
                    />
                    <label htmlFor="endDate">{translation?.end_date || "End Date"}</label>
                  </div>
                </div>
                {compareCalender && (
                  <>
                    <h6 className="compare-title">{translation?.compare || "Compare"}</h6>
                    <div className="form">
                      <div className="form-item">
                        <input
                          type="text"
                          id="startDate"
                          name="startDateC"
                          autoComplete="off"
                          required
                          onChange={(e) => handlerDateSelect(e, true)}
                          onFocus={() => setIsFocused(true)}
                          onBlur={() => setIsFocused(false)}
                          {...(!isFocused
                            ? {
                                value: moment(cState[0]?.startDate).format(
                                  "MMM DD, YYYY"
                                ),
                              }
                            : {
                                defaultValue: moment(
                                  cState[0]?.startDate
                                ).format("MMM DD, YYYY"),
                              })}
                        />
                        <label htmlFor="startDate">{translation?.start_date || "Start Date"}</label>
                      </div>
                      <div className="form-item">
                        <input
                          type="text"
                          id="endDate"
                          name="endDate"
                          onChange={(e) => handlerDateSelect(e, true)}
                          onFocus={() => setIsFocused(true)}
                          onBlur={() => setIsFocused(false)}
                          {...(!isFocused
                            ? {
                                value: moment(cState[0]?.endDate).format(
                                  "MMM DD, YYYY"
                                ),
                              }
                            : {
                                defaultValue: moment(cState[0]?.endDate).format(
                                  "MMM DD, YYYY"
                                ),
                              })}
                          autoComplete="off"
                          required
                        />
                        <label htmlFor="endDate">{translation?.end_date || "End Date"}</label>
                      </div>
                    </div>
                  </>
                )}

                <DateRange
                  onChange={handleSelect}
                  months={1}
                  // staticRanges={predefinedRanges}
                  inputRanges={[]}
                  showSelectionPreview={true}
                  moveRangeOnFirstSelection={false}
                  direction="vertical"
                  scroll={{ enabled: true }}
                  ranges={!compareCalender ? state : cState}
                  minDate={new Date(2022, 0, 1)} 
                  maxDate={maxDate && today}
                  className="date-range-calendar"
                />
              </div>
            </div>
            <div className="button-wrapper">
              <button
                className="cancel btn btn-primary-light"
                onClick={() => cancelbtn()}
              >
                {translation?.cancel || "Cancel"}

              </button>
              <button
                className="apply btn btn-primary"
                onClick={() => submit()}
              >
                {translation?.apply || "Apply"}

              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
);

export default CustomDateRangePicker;
